import React, { useEffect, useRef } from 'react';
import './Hero.css';

function Hero() {

  const imageContainerRef = useRef(null);
  const profileImgRef = useRef(null);

  useEffect(() => {
    const container = imageContainerRef.current;
    const img = profileImgRef.current;

    if (!container || !img) return;

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateY = ((x - centerX) / centerX) * 15; // left-right tilt
      const rotateX = ((centerY - y) / centerY) * 12; // up-down tilt

      img.style.transform = `
        translateX(-50%)
        translateY(-55px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
        scale(1.06)
      `;
    };

    const handleMouseLeave = () => {
      img.style.transform = `
        translateX(-50%)
        translateY(-55px)
        rotateX(0deg)
        rotateY(0deg)
        scale(1)
      `;
    };

    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h2 className="greeting">
              <span className="terminal">
                <span className="typing code">print("Hello World!") </span>
                <span className="output">&gt;&gt; Hello World!</span>
              </span>
            </h2>

            <h1 className="hero-title">I'm Rahim Biswas.</h1>

            <p className="hero-description">
              I’m a Geospatial AI Engineer based in Hyderabad, India, driven by a passion for harnessing the power of GIS, machine learning, and artificial intelligence. My focus is on tackling complex spatial challenges, designing intelligent solutions that enhance decision-making, and contributing to the evolving landscape of GeoAI.
            </p>


            <div className="hero-social">
              <a
                href="https://www.linkedin.com/in/rahim-biswas/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="LinkedIn"
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>

              <a
                href="https://www.youtube.com/@spatia-ai"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="YouTube"
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a2.997 2.997 0 0 0-2.112-2.12C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.386.566a2.997 2.997 0 0 0-2.112 2.12C0 8.073 0 12 0 12s0 3.927.502 5.814a2.997 2.997 0 0 0 2.112 2.12C4.495 20.5 12 20.5 12 20.5s7.505 0 9.386-.566a2.997 2.997 0 0 0 2.112-2.12C24 15.927 24 12 24 12s0-3.927-.502-5.814zM9.75 15.5v-7l6.5 3.5-6.5 3.5z" />
                </svg>
              </a>

              <a
                href="https://github.com/Rahim-Biswas"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="GitHub"
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
              </a>
            </div>

            {/* <a href="#contact" className="btn btn-hero">Contact Me</a> */}
          </div>

          <div className="hero-image">
            <div className="image-container" ref={imageContainerRef}>

              {/* PROFILE IMAGE (3D POP-OUT EFFECT ADDED) */}
              <img
                ref={profileImgRef}
                className="profile-3d"
                src="/images/profile.png"
                alt="Rahim Biswas"
              />

              <div className="image-decoration decoration-1">
                <span className="map-emoji">🗺️</span>
              </div>



              <div className="image-decoration decoration-2">
                <div class="map-pin">
                  <svg width="60" height="60" viewBox="0 0 64 64" fill="none">


                    <ellipse cx="32" cy="56" rx="12" ry="4" fill="rgba(0,0,0,0.25)" />


                    <path
                      d="M32 4C21 4 12 13 12 24c0 16 20 36 20 36s20-20 20-36C52 13 43 4 32 4z"
                      fill="url(#pinGradient)"
                      stroke="#111"
                      stroke-width="2"
                    />
                    <circle cx="32" cy="24" r="9" fill="white" stroke="#111" stroke-width="2" />
                    <circle cx="32" cy="24" r="4" fill="#ff3b3b" />
                    <defs>
                      <linearGradient id="pinGradient" x1="12" y1="4" x2="52" y2="60">
                        <stop offset="0%" stop-color="#ff4d4d" />
                        <stop offset="100%" stop-color="#b30000" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>


              </div>

              <div className="image-decoration decoration-3">
                <div className="globe-gif">
                  <img
                    src="/images/Satellite around Earth.gif"
                    alt="Satellite around Earth"
                    className="globe-gif"
                  />
                </div>
              </div>


              <div className="badge">Being Mappy</div>
            </div>
          </div>
        </div>

        <div className="tech-stack">

          <div className="tech-item">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="Python" />
            <span>Python</span>
          </div>

          <div className="tech-item">
            <img src="https://www.esri.com/content/dam/esrisites/en-us/common/icons/product-logos/ArcGIS-Pro.png" alt="ArcGIS Pro" />
            <span>ArcGIS Pro / ArcPy</span>
          </div>

          <div className="tech-item">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg" alt="FastAPI" />
            <span>FastAPI</span>
          </div>

          <div className="tech-item">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="PostgreSQL" />
            <span>PostgreSQL / PostGIS</span>
          </div>

          <div className="tech-item">
            <img src="https://i.pinimg.com/736x/63/d9/9d/63d99d08975a20177ec3057bda142801.jpg" alt="QGIS" />
            <span>QGIS / PyQGIS</span>
          </div>



          <div className="tech-item">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL0NintRd0-dpSExc9vTuznwTMa3GnMFJqWA&s" alt="Google Earth Engine" />
            <span>GEE / GEE Python API</span>
          </div>

          <div className="tech-item">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYgDni61fImLmbS7es-r4Vsbc782DmR-HvmQ&s" alt="Deep Learning" />
            <span>Deep Learning (Mask R-CNN / SamGeo / YOLO)</span>
          </div>

          <div className="tech-item">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="Git" />
            <span>Git / GitHub</span>
          </div>

          <div className="tech-item">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVNSl49nHGe7jG1sQnG1OBkcm6s3AF6378fSnePk3NIg&s" alt="PythonLibs" />
            <span>Geoai-py / WhiteboxTools / GDAL / GeoPandas</span>
          </div>

          <div className="tech-item">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIcl4_InC090b0qsYY9fvGC9-xvGCEEx93_9jgj7W_XA&s=10" alt="Geoserver" />
            <span>GeoServer</span>
          </div>

          <div className="tech-item">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROXKcoR-l79liakYwwaNOtfvKh2Dh801jUfcQeip_rMA&s=10" alt="AWS" />
            <span>AWS (EC2, S3)</span>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Hero;
